/* istanbul ignore file */
import styled from 'styled-components';
import { Paper } from '@econsult/econsult-ui/dist/components/Paper';
import { ArrowDownIcon, ArrowRightIcon, StartIcon } from 'assets';

export const ScrollableContainerOuterWithVerticalScrollbar = styled.div`
  padding-bottom: 30px;
  float: bottom;
  height: auto;
  position: relative;
  max-height: 50vh;
  overflow-y: auto;

  @media (max-width: 600px) {
    max-height: 40vh;
  }
`;

export const TranscriptionTile = styled(Paper)`
  height: auto;
  min-height: 15rem;
  max-height: 60vh;
  overflow-y: auto;
  margin-top: 8px;

  @media (max-width: 600px) {
    min-height: 10rem;
    max-height: 50vh;
  }
`;

export const TranscriptionToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const StyledStartIcon = styled(StartIcon)`
  height: 11px !important;
  width: 9px !important;
  padding: 0;
  margin: 0;
`;

export const StyledArrowDown = styled(ArrowDownIcon)`
  width: 20px;
  height: 20px;
  padding: 0;
  margin: 0;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
`;

export const StyledArrowRight = styled(ArrowRightIcon)`
  width: 20px;
  height: 20px;
  padding: 0;
  margin: 0;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
`;
